// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-loader[data-v-0a4e0268]{width:100%;height:100vh;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
